import { ProcessPageDict } from '@adapters/navigation/page';
import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { Account } from '@core/model/domain/account';
import { Bank } from '@modules/process/models/bank';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { TrackerService } from '@shared/services/tracker.service';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';

@Component({
  selector: 'app-accounts-answer',
  templateUrl: './accounts-answer.component.html',
  styleUrls: ['./accounts-answer.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})
export class AccountsAnswerComponent implements OnInit {
  isPopinOpen = false;
  status!: string;
  selectedAccount!: Account[];
  taggingPayload!: {
    pageType: 'result_page' | 'bank_detail';
    status: string;
  };

  constructor(
    private processEventService: ProcessEventService,
    private storeService: StoreService,
    private tracker: TrackerService
  ) {}

  ngOnInit(): void {
    const params = this.storeService.getVariableOrThrow(
      'PROCESS_PAGE_PARAMS'
    ) as ProcessPageDict['SELECT_ACCOUNTS_ANSWER'];
    this.status = params.status;
    this.selectedAccount = params.selectedAccount;
    this.taggingPayload = {
      pageType: params.taggingEventOrigin,
      status: params.status,
    };

    this.tracker.trackPage({
      taggingPage: 'SELECT_ACCOUNTS_ANSWER',
      taggingPayload: this.taggingPayload,
    });
  }

  continueSuccess() {
    this.tracker.trackClick({
      click: frenchi18n.common_continue,
      taggingPage: 'SELECT_ACCOUNTS_ANSWER',
      taggingPayload: this.taggingPayload,
    });
    this.processEventService.push(ProcessEventFactory.SpawnContinueEvent());
  }

  continueFailure() {
    this.tracker.trackClick({
      click: frenchi18n.common_continue,
      taggingPage: 'SELECT_ACCOUNTS_ANSWER',
      taggingPayload: this.taggingPayload,
    });

    this.processEventService.push(ProcessEventFactory.SpawnContinueAfterErrorEvent());
  }

  selectBank() {
    this.tracker.trackClick({
      click: frenchi18n.connect_to_other_bank_btn,
      taggingPage: 'SELECT_ACCOUNTS_ANSWER',
      taggingPayload: this.taggingPayload,
    });

    this.processEventService.push(ProcessEventFactory.SpawnGoBackToBankChoiceEvent());
  }

  selectAccount() {
    this.processEventService.push(ProcessEventFactory.SpawnAccountsFoundEvent(this.foundAccounts));
  }

  closePopin() {
    this.isPopinOpen = false;
  }

  abandon() {
    this.processEventService.push(ProcessEventFactory.SpawnAbandonEvent());
  }

  openPopin() {
    this.tracker.trackClick({
      click: frenchi18n.select_accounts_abandon,
      taggingPage: 'SELECT_ACCOUNTS_ANSWER',
      taggingPayload: this.taggingPayload,
    });

    this.isPopinOpen = true;
  }

  get selectedBank(): Bank {
    return this.storeService.getVariableOrThrow('SELECTED_BANK');
  }

  set selectedBank(value: Bank) {
    this.storeService.setVariable('SELECTED_BANK', value);
  }

  get foundAccounts(): Account[] {
    return this.storeService.getVariableOrThrow('FOUND_ACCOUNTS');
  }

  set foundAccounts(value: Account[]) {
    this.storeService.setVariable('FOUND_ACCOUNTS', value);
  }
}
